<template>
  <div class="">
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="tits"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editFormRules"
        class="demo-editForm"
        label-width="120px"
      >
        <el-form-item label="商品名" label-width="120px" required>
          <el-input v-model="editForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品分类" label-width="120px" required>
          <el-cascader
            ref="cateData"
            v-model="classifyId"
            :options="typeList"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            clearable
            filterable
            placeholder="选择分类"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="是否可拼团" label-width="120px">
          <el-radio-group v-model="editForm.isGroupBuying">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="editForm.isGroupBuying == 1"
          label="拼团人数"
          label-width="120px"
        >
          <el-input
            v-model="editForm.groupBuyingNum"
            autocomplete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否是限时秒杀" label-width="120px">
          <el-radio-group v-model="editForm.isLimitedTimeDiscount">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="editForm.isLimitedTimeDiscount == 1"
          label="限时秒杀人数"
          label-width="120px"
        >
          <el-input
            v-model="editForm.limitedTimeDiscountNum"
            autocomplete="off"
            type="Number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="editForm.isLimitedTimeDiscount == 1"
          label="限时秒杀时效"
          label-width="120px"
        >
          <el-date-picker
            v-model="editForm.limitedTimeDiscountEndTime"
            format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            style="width: 100%"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          v-if="editForm.isLimitedTimeDiscount == 1"
          label="限时秒杀件数"
          label-width="120px"
        >
          <el-input
            v-model="editForm.limitedTimeDiscountCommodityNum"
            autocomplete="off"
            type="Number"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否为赠品" label-width="120px">
          <el-radio-group v-model="editForm.isGift">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品规格" label-width="120px">
          <div
            v-for="(item, index) in editForm.commoditSpecificationsList"
            :key="index"
          >
            <el-row>
              <el-col :span="24" style="margin-bottom: 20px">
                <el-form-item
                  :label="'规格 ' + (index + 1)"
                  label-width="80px"
                  required
                >
                  <el-input
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .commoditSpecifications
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="margin-bottom: 20px">
                <el-form-item label="原价" label-width="80px">
                  <el-input
                    type="number"
                    v-model="
                      editForm.commoditSpecificationsList[index].originalPrice
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="8" style="margin-bottom: 20px">
                <el-row>
                  <el-col :span="14">
                    <el-form-item label-width="80px">
                      <el-input
                        v-model="
                          editForm.commoditSpecificationsList[index]
                            .sellingPriceName
                        "
                        clearable
                        placeholder="售价名称"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="text-align: center">:</el-col>
                  <el-col :span="9">
                    <el-form-item label-width="0px">
                      <el-input
                        v-model="
                          editForm.commoditSpecificationsList[index].price
                        "
                        clearable
                        type="number"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8" style="margin-bottom: 20px">
                <el-row>
                  <el-col :span="14">
                    <el-form-item label-width="80px">
                      <el-input
                        v-model="
                          editForm.commoditSpecificationsList[index]
                            .storePriceName
                        "
                        clearable
                        placeholder="达人价名称"
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="text-align: center">:</el-col>
                  <el-col :span="9">
                    <el-form-item label-width="0px">
                      <el-input
                        type="number"
                        v-model="
                          editForm.commoditSpecificationsList[index].storePrice
                        "
                        clearable
                        autocomplete="off"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col
                :span="8"
                v-if="editForm.isGift == 1"
                style="margin-bottom: 20px"
              >
                <el-form-item label="库存" label-width="80px">
                  <el-input
                    type="number"
                    v-model="
                      editForm.commoditSpecificationsList[index].inventory
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="editForm.isGroupBuying == 1"
                style="margin-bottom: 20px"
              >
                <el-form-item label="拼团价" label-width="80px">
                  <el-input
                    type="number"
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .groupBuyingPrice
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col
                :span="8"
                v-if="editForm.isLimitedTimeDiscount == 1"
                style="margin-bottom: 20px"
              >
                <el-form-item label="秒杀价" label-width="80px">
                  <el-input
                    type="number"
                    v-model="
                      editForm.commoditSpecificationsList[index]
                        .limitedTimeDiscountPrice
                    "
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="margin: 20px 33%">
                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  round
                  @click="add1(index)"
                  >新增规格</el-button
                >
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  round
                  @click="del1(index)"
                  >删除规格</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="单位" label-width="120px" required>
          <el-input v-model="editForm.unit" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品标签" label-width="120px">
          <div v-for="(item, index) in editForm.productLabelsList" :key="index">
            <el-row>
              <el-col :span="18">
                <el-input
                  v-model="editForm.productLabelsList[index]"
                  autocomplete="off"
                ></el-input>
              </el-col>
              <el-col :span="3">
                <i
                  class="el-icon-circle-plus-outline"
                  style="color: #67c23a; margin: 0 30px"
                  @click="add(index)"
                ></i>
                <i
                  class="el-icon-delete"
                  style="color: #f56c6c"
                  @click="del(index)"
                ></i>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item label="商品参数" label-width="120px" required>
          <el-input v-model="editForm.parameters" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="是否是热门" label-width="120px">
          <el-radio-group v-model="editForm.isHot">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否推荐" label-width="120px">
          <el-radio-group v-model="editForm.isRecommend">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否是新品上市" label-width="120px">
          <el-radio-group v-model="editForm.isNewProductLaunch">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品说明" label-width="120px" required>
          <el-input v-model="editForm.explain" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="运费" label-width="120px">
          <el-input v-model="editForm.freight" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" label-width="120px">
          <el-input v-model="editForm.sort" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-if="dialogVisible"
          label="商品详情"
          label-width="120px"
          required
        >
          <Editor
            v-model="editForm.imgDetail"
            :min-height="192"
            @change="changedetail"
          />
        </el-form-item>
        <el-form-item
          v-if="dialogVisible"
          label="三证信息"
          required
          label-width="120px"
        >
          <Editor
            v-model="editForm.threeCertificateInformation"
            :min-height="192"
            @change="changethreeCert"
          />
        </el-form-item>

        <el-form-item label="封面" label-width="140px">
          <VploadImgs
            :limit="1"
            :multble="false"
            :type="1"
            v-bind:file-list="filesd"
            @submitImg="getImg"
          >
          </VploadImgs>
        </el-form-item>
        <div style="height: 30px"></div>
        <el-form-item label="轮播图" label-width="140px" required>
          <VploadImgFour
            :fileData="fileData"
            :fileSize="fileSize"
            :fileType="fileType"
            :limit="10"
            :value="editForm.imgList"
            @input="getImgList"
          >
          </VploadImgFour>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary" @click="saveAndNext('editForm')"
            >保存
          </el-button>
          <!-- <el-button @click="resetForm('editForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VploadImg from "../../inc/VploadImgTwo";
import VploadImgs from "../../inc/VploadImgThree";
import VploadImgFour from "../../inc/VploadImgFour";
import TinymceEditor from "../../inc/TinymceEditor";
import Editor from "@/components/Tinymce/index";

export default {
  name: "SingProduct",
  components: {
    VploadImg,
    VploadImgs,
    TinymceEditor,
    Editor,
    VploadImgFour,
  },
  props: {
    storeGoodsId: {
      type: Number,
    },
    storeGoodsStatus: {
      type: Number,
    },
  },
  data() {
    return {
      fileData: {
        type: 0,
        fileType: 0,
      },
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      editForm: {
        imgList: "",
        imgDetail: "",
      },
      fileList: [],
      relGardenName: "",
      fileLists: [],
      filesd: [],
      banlist: [],
      typeList: [],
      urlList: [],
      supList: [],
      brolist: [],
      adrssData: [],
      id: "",
      fengbron: [],
      fengone: [],
      fengtwo: [],
      fengtress: [],
      cover: "",
      storeGoodsPackageList: [],
      totalCartons: 0,
      ispostage: false,
      dialogFormVisibleAdd: false,
      dialogVisible: true,
      getTagvisible: false,
      getGardenvisible: false,
      editFormRules: {},
      bled: false,
      classifyId: [],
      editor: "",
      elementById: "",
      elementById1: "",
      editor1: "",
      did: "",
      tits: "添加商品",
      f: false,
    };
  },
  watch: {
    storeGoodsId(n, o) {
      //n为新值,o为旧值;
      this.storeGoodsId = n;
    },
    storeGoodsStatus(n, o) {
      this.storeGoodsStatus = n;
    },
  },
  created() {
    this.getTypeList();
    this.supp();
  },
  methods: {
    add(i) {
      this.editForm.productLabelsList.splice(i + 1, 0, "");
    },
    del(i) {
      if (this.editForm.productLabelsList.length == 1) {
        this.editForm.productLabelsList = [""];
      } else {
        this.editForm.productLabelsList.splice(i, 1);
      }
    },

    add1(i) {
      this.editForm.commoditSpecificationsList.splice(i + 1, 0, {
        commoditId: "",
        commoditSpecifications: "",
        commoditSpecificationsId: "",
        inventory: "",
        originalPrice: "",
        price: "",
        limitedTimeDiscountPrice: "",
        groupBuyingPrice: "",
        storePrice: "",
        storePriceName: "达人价",
        sellingPriceName: "售价",
      });
    },
    del1(i) {
      if (this.editForm.commoditSpecificationsList.length == 1) {
        this.editForm.commoditSpecificationsList = [
          {
            commoditId: "",
            commoditSpecifications: "",
            commoditSpecificationsId: "",
            inventory: "",
            originalPrice: "",
            limitedTimeDiscountPrice: "",
            price: "",
            groupBuyingPrice: "",
            storePrice: "",
            storePriceName: "达人价",
            sellingPriceName: "售价",
          },
        ];
      } else {
        this.editForm.commoditSpecificationsList.splice(i, 1);
      }
    },

    changedetail(e) {
      this.editForm.imgDetail = e;
    },
    changethreeCert(e) {
      this.editForm.threeCertificateInformation = e;
    },
    resetForm(e) {
      this.classifyId = e;
    },
    supp() {
      this.$axios.get("/admin/brand/getBrandListNoPage").then((res) => {
        this.supList = res.data;
      });
    },
    ForMat(date, fmt) {
      var date = new Date(date);
      let obj = {
        y: date.getFullYear(), // 年份，注意必须用getFullYear
        M: date.getMonth() + 1, // 月份，注意是从0-11
        d: date.getDate(), // 日期
        q: Math.floor((date.getMonth() + 3) / 3), // 季度
        H: date.getHours(), // 24小时制
        h: date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
        m: date.getMinutes(), // 分钟
        s: date.getSeconds(), // 秒
        S: date.getMilliseconds(), // 毫秒
      };
      for (let i in obj) {
        fmt = fmt.replace(new RegExp(i + "+", "g"), function (m) {
          let val = String(obj[i]);
          for (let j = 0, len = val.length; j < m.length - len; j++) {
            val = "0" + val;
          }
          return m.length === 1 ? val : val.substring(val.length - m.length);
        });
      }
      return fmt;
    },
    init(e, d, f) {
      var that = this;
      that.did = d;
      console.log("666", f);
      if (f) {
        that.f = true;
      } else {
        that.f = false;
      }
      if (e) {
        this.id = e;
        if (d) {
          this.tits = "编辑商品";
        } else {
          this.tits = "添加商品";
        }
        this.bled = true;
        this.$axios
          .post("/admin/commodity/getCommodityDetail", {
            id: e,
          })
          .then((res) => {
            var dat = res.data;
            var arrd = [];
            var arrm = [];
            this.editForm = {
              sort: dat.sort,
              brandId: dat.brandId,
              classifyId: dat.classifyId,
              imgDetail: dat.imgDetail,
              limitedTimeDiscountCommodityNum:
                dat.limitedTimeDiscountCommodityNum,
              isRecommend: dat.isRecommend,
              threeCertificateInformation: dat.threeCertificateInformation,
              explain: dat.explain,
              productLabelsList: dat.productLabelsList
                ? dat.productLabelsList
                : [""],
              commoditSpecificationsList: dat.commoditSpecificationsList,
              unit: dat.unit,
              isGroupBuying: dat.isGroupBuying,
              groupBuyingNum: dat.groupBuyingNum,
              limitedTimeDiscountEndTime: dat.limitedTimeDiscountEndTime
                ? this.ForMat(
                    new Date(dat.limitedTimeDiscountEndTime),
                    "yyyy-MM-dd HH:mm:ss",
                  )
                : "",
              limitedTimeDiscountNum: dat.limitedTimeDiscountNum,
              freight: dat.freight,
              isHot: dat.isHot,
              isGift: dat.isGift,
              isLimitedTimeDiscount: dat.isLimitedTimeDiscount,
              isNewProductLaunch: dat.isNewProductLaunch,
              name: dat.name,
              parameters: dat.parameters,
              imgList: dat.imgList.toString(),
            };

            var cass = [];
            setTimeout(function () {
              cass[0] = Number(dat.firstClassifyId);
              cass[1] = "a" + dat.classifyId;
              that.resetForm(cass);
            }, 400);
            this.filesd = [];
            if (dat.videoCover != null) {
              arrm = dat.videoCover.split(",");
              arrm.map((item, index) => {
                var fis = {
                  url: item,
                };
                this.filesd.push(fis);
              });
            }
            console.log("mini1111", dat.imgDetail);
            if (that.editor != "") {
              that.editor.txt.html(dat.imgDetail);
            }
          });

        that.dialogVisible = true;
      } else {
        this.tits = "添加商品";
        this.bled = false;
        this.editForm = {
          brandId: "",
          sort: 0,
          isGift: 0,
          classifyId: "",
          imgDetail: "",
          explain: "",
          intro: "",
          isGroupBuying: 0,
          unit: "",
          groupBuyingNum: "",
          limitedTimeDiscountNum: "",
          limitedTimeDiscountEndTime: "",
          isHot: 0,
          freight: "",
          isRecommend: 0,
          limitedTimeDiscountCommodityNum: "",
          isLimitedTimeDiscount: 0,
          threeCertificateInformation: "",
          name: "",
          productLabelsList: [""],
          parameters: "",
          videoId: "sphHynY8sojAwpC",
          videoUrl: "",
          isNewProductLaunch: 0,
          imgList: "",
          commoditSpecificationsList: [
            {
              commoditId: "",
              commoditSpecifications: "",
              commoditSpecificationsId: "",
              inventory: "",
              originalPrice: "",
              limitedTimeDiscountPrice: "",
              price: "",
              groupBuyingPrice: "",
              storePrice: "",
              storePriceName: "达人价",
              sellingPriceName: "售价",
            },
          ],
        };

        this.id = "";
        this.classifyId = [];
        this.fileList = [];
        this.fileLists = [];
        this.filesd = [];
        this.fengone = [];
        this.fengtwo = [];
        this.dialogVisible = true;
        that.editor.txt.html("");
      }
    },
    handleClose() {
      this.editForm = {
        bannerCover: "",
        discountExplain: "",
        residueCartons: "",
        storeGoodWeight: "",
        intro: "",
        isGift: 0,
        sort: 0,
        unit: "",
        brochureImage: "",
        limitedTimeDiscountCommodityNum: "",
        storeGoodsCover: "",
        storeGoodsName: "",
        isRecommend: 0,
        productId: "",
        limitedTimeDiscountEndTime: "",
        threeCertificateInformation: "",
        limitedTimeDiscountNum: "",
        storeGoodsOriginalPrice: "",
        storeGoodsPrice: "",
        storeGoodsTypeId: "",
        commoditSpecificationsList: [
          {
            commoditId: "",
            commoditSpecifications: "",
            commoditSpecificationsId: "",
            inventory: "",
            originalPrice: "",
            limitedTimeDiscountPrice: "",
            price: "",
            groupBuyingPrice: "",
            storePrice: "",
            storePriceName: "达人价",
            sellingPriceName: "售价",
          },
        ],
        freight: "",
        groupBuyingNum: "",
        productLabelsList: [],
        isGroupBuying: 0,
        producingAreaId: "",
        supplierId: "",
        slideshow: "",
        imgList: "",
      };
      this.id = "";
      this.fileList = [];
      this.fileLists = [];
      this.filesd = [];
      this.fengone = [];
      this.fengtwo = [];
      this.fengtress = [];
      this.dialogVisible = false;
    },

    getTypeList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.typeList = res.data;
        });
    },
    getImgList(url) {
      this.editForm.imgList = url;
    },

    getImg(url, add) {
      if (add == 1) {
        this.fengone.push(url);
      } else if (add == 0) {
        if (this.fengone == null || this.fengone.length < 1) {
          return;
        }
        this.fengone.some((item, i) => {
          if (item == url) {
            this.fengone.splice(i, 1);
            //在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
            return true;
          }
        });
      }

      this.editForm.videoCover = this.fengone.join(",");
    },
    //   保存并下一步
    saveAndNext(formName) {
      if (!this.editForm.name) {
        this.$message({
          showClose: true,
          message: "商品名称不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }

      if (this.classifyId.length == 0) {
        this.$message({
          showClose: true,
          message: "商品分类不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }

      const list = this.editForm.commoditSpecificationsList || [];

      if (!list.length) {
        this.$message({
          showClose: true,
          message: "请至少添加一个商品规格",
          type: "info",
          onClose: () => {},
        });
        return;
      }

      for (let i = 0; i < list.length; i++) {
        const item = list[i] || {};
        const indexText = `第${i + 1}条规格`;
        if (
          item.commoditSpecifications === "" ||
          item.commoditSpecifications === null ||
          item.commoditSpecifications === undefined
        ) {
          this.$message({
            showClose: true,
            message: `${indexText}的商品规格名称不能为空`,
            type: "info",
            onClose: () => {},
          });
          return;
        }
        if (
          item.originalPrice === "" ||
          item.originalPrice === null ||
          item.originalPrice === undefined
        ) {
          this.$message({
            showClose: true,
            message: `${indexText}的原价不能为空`,
            type: "info",
            onClose: () => {},
          });
          return;
        }
        // 售价必填
        if (
          item.price === "" ||
          item.price === null ||
          item.price === undefined
        ) {
          this.$message({
            showClose: true,
            message: `${indexText}的售价不能为空`,
            type: "info",
            onClose: () => {},
          });
          return;
        }
        // 达人价必填
        if (
          item.storePriceName === "" ||
          item.storePriceName === null ||
          item.storePriceName === undefined
        ) {
          this.$message({
            showClose: true,
            message: `${indexText}的达人售价名称不能为空`,
            type: "info",
            onClose: () => {},
          });
          return;
        }
        if (
          item.storePrice === "" ||
          item.storePrice === null ||
          item.storePrice === undefined
        ) {
          this.$message({
            showClose: true,
            message: `${indexText}的达人价不能为空`,
            type: "info",
            onClose: () => {},
          });
          return;
        }
        if (
          item.sellingPriceName === "" ||
          item.sellingPriceName === null ||
          item.sellingPriceName === undefined
        ) {
          this.$message({
            showClose: true,
            message: `${indexText}的售价名称不能为空`,
            type: "info",
            onClose: () => {},
          });
          return;
        }
      }

      if (this.classifyId.length > 0) {
        this.typeList.map((item) => {
          item.children.map((itrs) => {
            if (this.classifyId[1] == itrs.id) {
              this.editForm.classifyId = itrs.uid;
            }
          });
        });
      } else {
        this.editForm.classifyId = "";
      }
      if (!this.editForm.unit) {
        this.$message({
          showClose: true,
          message: "单位不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }
      if (this.editForm.parameters == "") {
        this.$message({
          showClose: true,
          message: "商品参数不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }
      if (!this.editForm.imgDetail) {
        this.$message({
          showClose: true,
          message: "商品详情不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }

      // 添加三证信息验证
      if (!this.editForm.threeCertificateInformation) {
        this.$message({
          showClose: true,
          message: "三证信息不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }

      if (!this.editForm.imgList) {
        this.$message({
          showClose: true,
          message: "轮播图不能为空",
          type: "info",
          onClose: () => {},
        });
        return;
      }

      var obj = JSON.parse(JSON.stringify(this.editForm));
      obj.imgList = obj.imgList.split(",");

      if (this.id && this.did == 1) {
        obj.id = this.id;
        this.$axios
          .post("/admin/commodity/updateCommodity", obj)
          .then((res) => {
            this.dialogVisible = false;
            this.$emit("refreshDataList");
            this.$parent.$parent.storeGoodsStatus = obj.status;
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
                this.$emit("changeComponent1Data", 1);
              },
            });
          });
      } else {
        this.$axios.post("/admin/commodity/addCommodity", obj).then((res) => {
          this.dialogVisible = false;
          this.$emit("refreshDataList");
          this.$parent.$parent.storeGoodsStatus = obj.status;
          this.$message({
            showClose: true,
            message: "恭喜你，操作成功",
            type: "success",
            onClose: () => {
              this.$emit("changeComponent1Data", 1);
            },
          });
        });
      }
    },
  },
};
</script>

<style scoped></style>
